import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M37.129 3.136A24.886 24.886 0 0 0 25 0C11.194 0 .002 11.191 0 24.997l17.391-8.693L37.13 3.136ZM0 25.002C.002 38.808 11.194 50 25 50c4.401 0 8.536-1.139 12.129-3.136L17.39 33.696 0 25.002Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M39.212 4.431a25.033 25.033 0 0 0-2.084-1.295L0 24.996v.006l37.128 21.861c.717-.399 1.412-.83 2.084-1.295L4.279 25 39.212 4.43Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M43.478 24.069H40.5a2.365 2.365 0 0 0-.146-3.185 2.366 2.366 0 0 0 0-3.346l-.055.055c.924-.924.98-2.477.055-3.401L26.97 27.576a2.334 2.334 0 0 0 3.32-.01l.257-.236 6.41-.583v2.756h2.173V26.55l3.261-.296 1.087-2.184Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M27.175 30.436 25 29.349l2.175-1.087h14.13v2.174h-14.13Z"
}));
FlagAS.displayName = 'FlagAS';
export default withFlagWrapper(FlagAS);
//# sourceMappingURL=index.js.map